// extracted by mini-css-extract-plugin
module.exports = {"container":"WidgetApp_container__EQFmm"};